import { render } from "./BtnCellRederer.vue?vue&type=template&id=ff9da914&scoped=true"
import script from "./BtnCellRederer.vue?vue&type=script&lang=js"
export * from "./BtnCellRederer.vue?vue&type=script&lang=js"

import "./BtnCellRederer.vue?vue&type=style&index=0&id=ff9da914&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff9da914"]])

export default __exports__